// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"70704ea3","534":"87667af4"}[chunkId] + ".chunk.js";
};